import { CustomActions } from "@cv-invision/cv.component-library.ux";

/**
 * path is the uiSection: This property is mapped on the Enum DOCUMENT_RULES_UI_SECTIONS, and it is an agreement
 * between FE and BE for each section, since both systems are different, we need to ensure both are the same
 */
export const GENERAL_SCHEMA = [
	{
		label: 'Overview',
		route: 'intelligence/quality/overview',
		path: 'overview',
		basePath: 'intelligence/quality/',
		icon: 'fa-bullseye',
		module: 'quality',
		schema: '',
		badge: ''
	},
	{
		label: 'Arrival',
		route: 'intelligence/quality/arrival',
		path: 'arrival',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-layer-group',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Site',
		route: 'intelligence/quality/site',
		path: 'site',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-warehouse',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Subject',
		route: 'intelligence/quality/subject',
		path: 'subject',
		basePath: 'intelligence/quality/',
		icon: 'far fa-address-book',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Structures',
		route: 'intelligence/quality/structures',
		path: 'structures',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-boxes',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Neighborhood',
		route: 'intelligence/quality/neighborhood',
		path: 'neighborhood',
		basePath: 'intelligence/quality/',
		icon: 'far fa-building',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Improvements',
		route: 'intelligence/quality/improvements',
		path: 'improvements',
		basePath: 'intelligence/quality/',
		icon: 'far fa-wrench',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Project Information',
		route: 'intelligence/quality/projectinformation',
		path: 'projectinformation',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-file-invoice',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Project Analysis',
		route: 'intelligence/quality/projectanalysis',
		path: 'projectanalysis',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-chart-line',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Unit Description',
		route: 'intelligence/quality/unitdescription',
		path: 'unitdescription',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-kaaba',
		module: 'quality',
		title: 'Subject & Market',
		schema: '',
		badge: ''
	},
	{
		label: 'Comp Grid',
		route: 'intelligence/quality/comps',
		path: 'comps',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-border-all',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Sales Approach',
		route: 'intelligence/quality/salesapproach',
		path: 'salesapproach',
		basePath: 'intelligence/quality/',
		customIconClass: 'fas fa-donate',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Cost Approach',
		route: 'intelligence/quality/costapproach',
		path: 'costapproach',
		basePath: 'intelligence/quality/',
		customIconClass: 'fas fa-file-invoice-dollar',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Income Approach',
		route: 'intelligence/quality/incomeapproach',
		path: 'incomeapproach',
		basePath: 'intelligence/quality/',
		customIconClass: 'fas fa-dollar-sign',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Reconciliation',
		route: 'intelligence/quality/reconciliation',
		path: 'reconciliation',
		basePath: 'intelligence/quality/',
		customIconClass: 'fas fa-hand-holding-usd',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Pdf Review',
		route: 'intelligence/quality/pdfreview',
		path: 'pdfreview',
		basePath: 'intelligence/quality/',
		customIconClass: 'fas fa-file-pdf',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Photos Review',
		route: 'intelligence/quality/photoreview',
		path: 'photoreview',
		basePath: 'intelligence/quality/',
		customIconClass: 'far fa-images',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Virtual Tour',
		route: 'intelligence/quality/virtualtour',
		path: 'virtualtour',
		basePath: 'intelligence/quality/',
		icon: 'fas fa-vr-cardboard',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: ''
	},
	{
		label: 'Help Center',
		route: null,
		path: 'helpcenter',
		basePath: 'intelligence/quality/',
		icon: 'far fa-circle-question',
		module: 'quality',
		title: 'Valuation',
		schema: '',
		badge: '',
		scrollable: true,
		actions:{
			click: CustomActions.OPEN_HELPDESK,
		}
	}
];



